export interface PricingConfig {
  creditsPerUsd: number;
  overheadFactor: number;
  targetMargin: number;
  paymentFeeRate: number;
  taxRate: number;
  fxBuffer: number;
}
export function computePricing(input: {
  credits: number;
  utilization: number;
  config: PricingConfig;
  vndPerUsd: number | null;
}) {
  const { credits, utilization, config, vndPerUsd } = input;
  const unitCostUsd = (credits / config.creditsPerUsd) * config.overheadFactor;
  const netRate = 1 - config.paymentFeeRate - config.taxRate;
  const breakEvenUsd = (unitCostUsd * utilization) / netRate;
  const suggestedUsd = (unitCostUsd * utilization * (1 + config.targetMargin)) / netRate;
  return {
    unitCostUsd,
    breakEvenUsd,
    suggestedUsd,
    suggestedVnd: vndPerUsd === null ? null : suggestedUsd * vndPerUsd * (1 + config.fxBuffer),
  };
}
export function marginAt(input: {
  priceUsd: number;
  credits: number;
  utilization: number;
  config: PricingConfig;
}): number {
  const consumedCost =
    (input.credits / input.config.creditsPerUsd) * input.config.overheadFactor * input.utilization;
  const netRevenue = input.priceUsd * (1 - input.config.paymentFeeRate - input.config.taxRate);
  return consumedCost === 0 ? 0 : netRevenue / consumedCost - 1;
}
